import { generateToken } from "../../../../shared/apiKeys";
import { hashScimToken } from "../../../../shared/scimTokenHash";
import { SCIM_TOKEN_PREFIX } from "../../../../shared/scimTokenPrefix";

export async function newScimToken(): Promise<{
  token: string;
  hash: string;
}> {
  const token = generateToken(SCIM_TOKEN_PREFIX);
  return { token, hash: await hashScimToken(token) };
}
